<template>
  <div class="page">
    <!-- 提示消息 -->
    <div class="success">
      <span>恭喜您，创建成功</span>
      <span>扫描二维码即可访问店铺</span>
    </div>
    <!-- 二维码 -->
    <div
      :class="{
        code: isCode,
        flipInY: isBounceOutLeft,
        animated: isAnimated
      }"
    >
      <div class="ikon">
        <img src="../assets/images/huangguan.jpg" alt="" />
      </div>
      <!-- 二维码logo -->
      <!-- <img class="code_logo" src="../assets/images/erweima.jpg" alt="" /> -->
      <!-- <div class="code_logo"> -->
      <qrcode class="qrcode code_logo" :value="short_url"></qrcode>
      <!-- </div> -->
      <!-- 店铺名 -->
      <div class="shop_name">
        {{ name }}
      </div>
      <!-- 店铺短链接 -->
      <!-- <van-field readonly v-model="short_url" type="textarea" autosize placeholder="短链接">
      </van-field> -->
      <div class="textarea">{{short_url}}</div>
       <van-button
          class="codeBtn"
          slot="button"
          size="small"
          plain
          type="info"
          :data-clipboard-text="short_url"
          @click="copyActiveCode($event, short_url)"
          >复制此链接</van-button
        >
      <!-- 推荐保存 -->
      <div class="save">推荐截图保存本页面</div>
    </div>
    <!-- 管理 -->
    <div class="hint">
      <div class="hint_title">
        <img src="../assets/images/wenti.jpg" alt="" />
        <span>如何管理店铺</span>
      </div>
      <div class="hint_content">
        <p>
          【推荐】使用电脑打开 panel.deiyoudian.com
          登录您的帐号即可上架商品做营销活动
        </p>
        <p>应用商店搜索 “得有店” APP下载客户端进行 管理店铺</p>
        <p>在使用过程中，有任何问题可联系专属客服一对 一为您解答</p>
      </div>
    </div>
    <van-button type="info" class="service">立即联系专属客服</van-button>
  </div>
</template>

<script>
import VueQrcode from '@xkeshi/vue-qrcode' // 二维码
import Clipboard from 'clipboard' // 复制到剪切板
import { Notify, Toast } from 'vant'
import { getStore } from '@/api/buy/shop'
export default {
  data() {
    return {
      short_url: '', // 短链接
      name: '', // 店铺名称
      isCode: true,
      isBounceOutLeft: false,
      isAnimated: false
    }
  },
  created() {
    // 获取店铺信息(店铺名称, 店铺短链接)
    let _this = this
    _this.$api.getStoreInfo().then(res => {
      console.log(res)
      if (res.code !== 200) {
        return Toast('店铺信息获取失败')
      }
      let shop = res.response
      _this.shorturl = shop.shorturl // 店铺短链接
      _this.name = shop.store_name // 店铺名称
      const cookie = _this.$cookie.get('platforminfo') 
      // console.log(JSON.parse(cookie))
      let link = JSON.parse(cookie).host.find(c => c.key == 2).value
      _this.short_url = `http://${link}/${_this.shorturl}`
    })
    // let shopInfo = JSON.parse(localStorage.getItem('params'))
    // this.short_url = shopInfo.short_url
    // console.log(this.$cookie.get('platforminfo'))
  },
  mounted() {
    // 翻转动画效果
    this.isBounceOutLeft = true
    this.isAnimated = true
  },
  components: {
    // 生成二维码
    Qrcode: VueQrcode
  },
  methods: {
    copyActiveCode() {
      const clipboard = new Clipboard('.codeBtn')
      clipboard.on('success', e => {
        Toast({
          message: '复制成功',
          position: 'top'
        })
      })
    }
  }
}
</script>

<style lang="css" scoped>
.success {
  display: flex;
  margin-top: 41px;
  margin-bottom: 109px;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  font-size: 24px;
  color: #333333;
}
.code {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  /* height: 392px; */
  margin: 0 auto;
  color: #333333;
  box-shadow: 0px 4px 12px 4px rgba(124, 134, 144, 0.1);
  border-radius: 6px;
  padding-top: 133px;
}
.ikon {
  width: 160px;
  height: 133px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
}
.ikon > img {
  width: 100%;
}
.code_logo {
  width: 150px;
  height: 150px;
  /* margin-top: 36px; */
}
.van-button--info {
  color: #fff;
  background-color: #3d6eff;
  border: 0.02667rem solid #3d6eff;
}
.codeBtn {
  border: none;
  margin-top: 10px;
  border-radius: 5px;
  background-color: #3d6eff;
  color: #ffffff !important;
}
.shop_name {
  margin: 15px 0;
  font-size: 16px;
  color: #333;
}
 /* 链接 */
.textarea {
  width: 260px;
  padding: 5px;
  background-color: #f8f8f8;
  border-radius: 10px;
  font-size: 16px;
  text-align: center;
  word-break: break-all;
}
.save {
  margin: 19px 0 24px 0;
  font-size: 14px;
  color: #999;
}
.hint {
  padding-top: 48px;
}
.hint_title {
  display: flex;
  align-items: center;
}
.hint_title > img {
  width: 21px;
  height: 21px;
  margin-right: 11px;
}
.hint {
  width: 296px;
  margin: 0 auto;
  font-size: 14px;
}
.van-cell {
  padding-right: 0;
}
.service {
  width: 100%;
}
.animated {
  animation-duration: 2s;
}
</style>
